import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import emailjs from "emailjs-com";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
    });
  }, []);

  // ✅ handle change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ handle submit
  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_6jdz19m",
        "template_p10nln5",
        formData,
        "MrtRm-rXyU6hasAsJ",
      )
      .then(() => {
        alert("Message sent successfully!");

        // reset form
        setFormData({
          name: "",
          email: "",
          mobile: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to send message");
      });
  };

  return (
    <div>
      <div className="contact">
        {/* HERO SECTION */}
        <section className="about-hero" data-aos="fade-up">
          <div className="hero-bg"></div>

          <div className="hero-content text-center text-white">
            <div className="container">
              <h1 className="fw-bold text-white">Contact Us</h1>
              <p className="mt-3">
                A leading national law firm delivering strategic, trusted legal
                solutions
              </p>
            </div>
          </div>
        </section>

        <div className="container mt-4" data-aos="fade-up" data-aos-delay="100">
          <div className="row">
            {/* LEFT SIDE */}
            <div className="col-md-6">
              <div className="contact-info">
                <div className="contact-item">
                  <i className="fa fa-map-marker-alt"></i>
                  <div className="contact-text">
                    <h2>Location</h2>
                    <p>
                      101, Krishna Leela Building,  <br /> Kolkhani lane, Ghatkopar  
                      East,  <br /> Mumbai – 400 077. 304,
                      <br className="mb-2"/> 
                      Swagat CHS, Sector – 44,   <br />Plot   – 84, Seawoods, Navi Mumbai
                      – 400 706.
                    </p>
                  </div>
                </div>

                <div className="contact-item">
                  <i className="fa fa-phone-alt"></i>
                  <div className="contact-text">
                    <h2>Phone</h2>
                    <p>+91 9224453365</p>
                  </div>
                </div>

                <div className="contact-item">
                  <i className="fa fa-envelope"></i>
                  <div className="contact-text">
                    <h2>Email</h2>
                    <p>videlicetlaw@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE FORM */}
            <div className="col-md-6">
              <div className="contact-form">
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <input
                      type="text"
                      name="mobile"
                      className="form-control"
                      placeholder="Mobile No."
                      required
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <textarea
                      name="message"
                      className="form-control"
                      placeholder="Message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div>
                    <button className="btn" type="submit">
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
